import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[appDataCSmask]',
  standalone: true,
})
export class DataCSmaskDirective {
  private attrValue: string;

  @HostBinding('attr.data-cs-mask') public get dataAttribute(): string {
    return this.attrValue;
  }

  @Input()
  public set appDataCSmask(value: boolean) {
    this.attrValue = value ? '' : null;
  }
}
